import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import InitiatedError from '../../entities/errors/InitiatedError';

export interface IQitafTvodGenerateOtpUseCase {
    execute(
        productId: string,
        qitafMsisdn: string,
        uid: string,
        apiKey: string,
        token: string,
        identityToken: string
    ): Promise<string>;
}

export class QitafTvodGenerateOtpUseCase implements IQitafTvodGenerateOtpUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get qitafTvodGenerateOtpRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        productId: string,
        qitafMsisdn: string,
        uid: string,
        apiKey: string,
        token: string,
        identityToken: string
    ): Promise<string> {
        const response = await this.qitafTvodGenerateOtpRepository.qitafTvodGenerateOtp(
            productId,
            qitafMsisdn,
            uid,
            apiKey,
            token,
            identityToken
        );
        if (response.data) {
            return response;
        }
        throw new InitiatedError('REF_ID_MISSING', 'Reference ID missing');
    }
}
